import Chamado_AdicionarDialog from './chamado/adicionar.dialog'
import Chamado_AdicionarDialogExternal from './chamado/adicionar.dialog.external'
import Chamado_AtribuirTecnicoDialog from './chamado/atribuir-tecnico.dialog'
import Chamado_EditarDialog from './chamado/editar.dialog'
import Chamado_KanbanCard from './chamado/kanban.card'
import Chamado_StatusBadge from './chamado/status.badge'
import Chamado_Table from './chamado/table'
import Chamado_TempoAtendimentoProgressBar from './chamado/tempo-atendimento.progress-bar'
import Evidencia_AdicionarDialog from './evidencia/adicionar.dialog'
import Evidencia_Galeria from './evidencia/galeria'
import Item_AdicionarDialog from './item/adicionar.dialog'
import Item_Table from './item/table'
import Tecnico_AtendimentoConcluirDialog from './tecnico/atendimento-concluir.dialog'
import Tecnico_AtendimentoIniciarDialog from './tecnico/atendimento-iniciar.dialog'
import Tecnico_EvidenciaAdicionarDialog from './tecnico/evidencia-adicionar.dialog'
import Tecnico_EvidenciaGaleriaCard from './tecnico/evidencia-galeria.card'

export const Chamados = {
  Core: {
    Adicionar_Dialog: Chamado_AdicionarDialog,
    Adicionar_Dialog_External: Chamado_AdicionarDialogExternal,
    AtribuirTecnico_Dialog: Chamado_AtribuirTecnicoDialog,
    Editar_Dialog: Chamado_EditarDialog,
    Kanban_Card: Chamado_KanbanCard,
    StatusBadge: Chamado_StatusBadge,
    Table: Chamado_Table,
    TempoAtendimento_ProgressBar: Chamado_TempoAtendimentoProgressBar,
  },
  Evidencias: {
    AdicionarDialog: Evidencia_AdicionarDialog,
    Galeria: Evidencia_Galeria,
  },
  Itens: {
    AdicionarDialog: Item_AdicionarDialog,
    Table: Item_Table,
  },
  Tecnico: {
    Atendimento: {
      Concluir_Dialog: Tecnico_AtendimentoConcluirDialog,
      Iniciar_Dialog: Tecnico_AtendimentoIniciarDialog,
    },
    Evidencias: {
      Adicionar_Dialog: Tecnico_EvidenciaAdicionarDialog,
      Galeria_Card: Tecnico_EvidenciaGaleriaCard,
    },
  },
}
